import { render, staticRenderFns } from "./ButtonColor.vue?vue&type=template&id=4b091196&"
import script from "./ButtonColor.vue?vue&type=script&lang=js&"
export * from "./ButtonColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports